import { apiErrorMessagesDe } from "../i18n/generated/apiErrorMessages.de";

/**
 * Schlüssel für API-Fehlermeldungen (z. B. 403-Body). Entsprechen den Backend-Konstanten in ApiErrorKeys.cs.
 * Das Frontend übersetzt diese Keys per i18n (translations.de/en) – keine Anzeige der Rohwerte.
 */
export const ApiErrorKeys = {
  RegistrationInvalid: "RegistrationInvalid",
  RegistrationPasswordWeak: "RegistrationPasswordWeak",
  RegistrationRateLimited: "RegistrationRateLimited",
  RegistrationDisabled: "RegistrationDisabled",
  RegistrationLimitReached: "RegistrationLimitReached",
  RegistrationConflict: "RegistrationConflict",
  RegistrationEmailNotConfigured: "RegistrationEmailNotConfigured",
  RegistrationEmailNotSent: "RegistrationEmailNotSent",
  RegistrationProvisioningFailed: "RegistrationProvisioningFailed",
  InvalidEmailConfirmationToken: "InvalidEmailConfirmationToken",
  E_RestPeriodCancelled: "E_RestPeriodCancelled",
  E_EntityInactive: "E_EntityInactive",
  E_EntityAlreadyUsed: "E_EntityAlreadyUsed",
  E_StudioQuotaReached: "E_StudioQuotaReached",
  E_StudioQuotaBelowActive: "E_StudioQuotaBelowActive",
  E_StudioOperationLocked: "E_StudioOperationLocked",
  E_StudioLockSelectionInvalid: "E_StudioLockSelectionInvalid",
  E_MemberLimitReached: "E_MemberLimitReached",
  E_UserLimitReached: "E_UserLimitReached",
  E_ReaderLimitReached: "E_ReaderLimitReached",
  E_TenantDeletionSubscriptionActive: "E_TenantDeletionSubscriptionActive",
  E_TenantDeletionAlreadyRequested: "E_TenantDeletionAlreadyRequested",
  E_TenantDeletionConfirmationMismatch: "E_TenantDeletionConfirmationMismatch",
  E_TenantDeletionPasswordInvalid: "E_TenantDeletionPasswordInvalid",
  E_TenantDeletionNotRevocable: "E_TenantDeletionNotRevocable",
  E_TenantDeletionFailed: "E_TenantDeletionFailed",
  ContractPackageAccessScopeInvalid: "ContractPackageAccessScopeInvalid",
  ContractPackageTemplatePublicHighlightsInvalid: "ContractPackageTemplatePublicHighlightsInvalid",
  PermissionDenied: "PermissionDenied",
  ValidationError: "ValidationError",
  TemplateSelectionInvalid: "TemplateSelectionInvalid",
  ReminderRoutingTemplateInvalid: "ReminderRoutingTemplateInvalid",
  ReminderTemplateSelectionRequired: "ReminderTemplateSelectionRequired",
  StudioAccessDenied: "StudioAccessDenied",
  AdminOnly: "AdminOnly",
  TenantImportCommitInProgress: "TenantImportCommitInProgress",
  TenantBackupRestoreInProgress: "TenantBackupRestoreInProgress",
  InboundEmailProviderUnavailable: "InboundEmailProviderUnavailable",
  InboundEmailAnalysisUnavailable: "InboundEmailAnalysisUnavailable",
  InboundEmailReanalysisInProgress: "InboundEmailReanalysisInProgress",
  InboundEmailReanalysisInvalidState: "InboundEmailReanalysisInvalidState",
  InboundEmailAccountHasMessages: "InboundEmailAccountHasMessages",
  InboundEmailInboxMaintenanceBusy: "InboundEmailInboxMaintenanceBusy",
  ActingAccountConfirmationRequired: "ActingAccountConfirmationRequired",
  AccountAbbreviationAlreadyTaken: "AccountAbbreviationAlreadyTaken",
  AccountEmailAlreadyTaken: "AccountEmailAlreadyTaken",
  AccountEmailCollidesWithUsername: "AccountEmailCollidesWithUsername",
  AccountUserIdentifiersConflict: "AccountUserIdentifiersConflict",
  AccountUsernameAlreadyTaken: "AccountUsernameAlreadyTaken",
  AccountUsernameCollidesWithEmail: "AccountUsernameCollidesWithEmail",
  DebtCollectionCaseOpenItemsRequired: "DebtCollectionCaseOpenItemsRequired",
  DebtCollectionCaseAgencyInvalid: "DebtCollectionCaseAgencyInvalid",
  DebtCollectionCaseOpenItemsNotAllowed: "DebtCollectionCaseOpenItemsNotAllowed",
  DebtCollectionCasePaymentNotAllowed: "DebtCollectionCasePaymentNotAllowed",
  DebtCollectionCaseCancellationNotAllowed: "DebtCollectionCaseCancellationNotAllowed",
  ArticleCannotDeleteInUse: "ArticleCannotDeleteInUse",
  ContractAmountMustNotBeNegative: "ContractAmountMustNotBeNegative",
  PriceAdjustmentRequiresPrimaryContract: "PriceAdjustmentRequiresPrimaryContract",
  PriceAdjustmentRequiresRecurringContract: "PriceAdjustmentRequiresRecurringContract",
  PriceAdjustmentStartBeforeContractStart: "PriceAdjustmentStartBeforeContractStart",
  WalletPaymentMethodRequired: "WalletPaymentMethodRequired",
  ContactBlockedCalls: "ContactBlockedCalls",
  ContactBlockedMessages: "ContactBlockedMessages",
  LeadContactChannelRequired: "LeadContactChannelRequired",
  LeadContactAppointmentNotFound: "LeadContactAppointmentNotFound",
  ReceptionContactStudioRequired: "ReceptionContactStudioRequired",
  ReceptionContactKindRequired: "ReceptionContactKindRequired",
  ReceptionContactPersonRequired: "ReceptionContactPersonRequired",
  ReceptionContactAppointmentAlreadySet: "ReceptionContactAppointmentAlreadySet",
  ReceptionContactLeadDefaultsInvalid: "ReceptionContactLeadDefaultsInvalid",
  MemberCarePipelineInvalid: "MemberCarePipelineInvalid",
  MemberCarePersonNotMember: "MemberCarePersonNotMember",
  MemberCareOpenCaseExists: "MemberCareOpenCaseExists",
  MemberCareEpisodeAlreadyHandled: "MemberCareEpisodeAlreadyHandled",
  MemberCareWithinReopenInterval: "MemberCareWithinReopenInterval"
} as const;

export const API_ERROR_KEYS_LIST: string[] = [
  ApiErrorKeys.ContractPackageAccessScopeInvalid,
  ApiErrorKeys.PermissionDenied,
  ApiErrorKeys.ValidationError,
  ApiErrorKeys.TemplateSelectionInvalid,
  ApiErrorKeys.ReminderRoutingTemplateInvalid,
  ApiErrorKeys.ReminderTemplateSelectionRequired,
  ApiErrorKeys.StudioAccessDenied,
  ApiErrorKeys.AdminOnly,
  ApiErrorKeys.TenantImportCommitInProgress,
  ApiErrorKeys.TenantBackupRestoreInProgress,
  ApiErrorKeys.InboundEmailProviderUnavailable,
  ApiErrorKeys.InboundEmailAnalysisUnavailable,
  ApiErrorKeys.InboundEmailReanalysisInProgress,
  ApiErrorKeys.InboundEmailReanalysisInvalidState,
  ApiErrorKeys.InboundEmailAccountHasMessages,
  ApiErrorKeys.InboundEmailInboxMaintenanceBusy,
  ApiErrorKeys.ActingAccountConfirmationRequired,
  ApiErrorKeys.AccountAbbreviationAlreadyTaken,
  ApiErrorKeys.AccountEmailAlreadyTaken,
  ApiErrorKeys.AccountEmailCollidesWithUsername,
  ApiErrorKeys.AccountUserIdentifiersConflict,
  ApiErrorKeys.AccountUsernameAlreadyTaken,
  ApiErrorKeys.AccountUsernameCollidesWithEmail,
  ApiErrorKeys.DebtCollectionCaseOpenItemsRequired,
  ApiErrorKeys.DebtCollectionCaseAgencyInvalid,
  ApiErrorKeys.DebtCollectionCaseOpenItemsNotAllowed,
  ApiErrorKeys.DebtCollectionCasePaymentNotAllowed,
  ApiErrorKeys.DebtCollectionCaseCancellationNotAllowed,
  ApiErrorKeys.ArticleCannotDeleteInUse,
  ApiErrorKeys.ContractAmountMustNotBeNegative,
  ApiErrorKeys.PriceAdjustmentRequiresPrimaryContract,
  ApiErrorKeys.PriceAdjustmentRequiresRecurringContract,
  ApiErrorKeys.PriceAdjustmentStartBeforeContractStart,
  ApiErrorKeys.WalletPaymentMethodRequired,
  ApiErrorKeys.ContactBlockedCalls,
  ApiErrorKeys.ContactBlockedMessages,
  ApiErrorKeys.LeadContactChannelRequired,
  ApiErrorKeys.LeadContactAppointmentNotFound,
  ApiErrorKeys.ReceptionContactStudioRequired,
  ApiErrorKeys.ReceptionContactKindRequired,
  ApiErrorKeys.ReceptionContactPersonRequired,
  ApiErrorKeys.ReceptionContactAppointmentAlreadySet,
  ApiErrorKeys.ReceptionContactLeadDefaultsInvalid,
  ApiErrorKeys.MemberCarePipelineInvalid,
  ApiErrorKeys.MemberCarePersonNotMember,
  ApiErrorKeys.MemberCareOpenCaseExists,
  ApiErrorKeys.MemberCareEpisodeAlreadyHandled,
  ApiErrorKeys.MemberCareWithinReopenInterval,
  ApiErrorKeys.RegistrationInvalid,
  ApiErrorKeys.RegistrationPasswordWeak,
  ApiErrorKeys.RegistrationRateLimited,
  ApiErrorKeys.RegistrationDisabled,
  ApiErrorKeys.RegistrationLimitReached,
  ApiErrorKeys.RegistrationConflict,
  ApiErrorKeys.RegistrationEmailNotConfigured,
  ApiErrorKeys.RegistrationEmailNotSent,
  ApiErrorKeys.RegistrationProvisioningFailed,
  ApiErrorKeys.InvalidEmailConfirmationToken
];

/** Keys aus ApiErrorKeys.Generated.cs (E_ + 16 hex). */
export function isDynamicApiErrorKey(value: string): boolean {
  return /^E_[a-f0-9]{16}$/.test(value);
}

/**
 * Sprechende Backend-Fehlerschlüssel, die nur in den generierten i18n-Katalogen stehen
 * (z. B. ReminderTemplateSelectionRequired). Ohne sie würde ein fachlicher 400er als
 * SystemFailure klassifiziert (Server-Log + Rohschlüssel im Toast).
 */
const GENERATED_API_ERROR_KEYS = new Set(Object.keys(apiErrorMessagesDe));

export function isApiErrorKey(value: string): value is (typeof ApiErrorKeys)[keyof typeof ApiErrorKeys] {
  return API_ERROR_KEYS_LIST.includes(value) || GENERATED_API_ERROR_KEYS.has(value) || isDynamicApiErrorKey(value);
}
